import _Object$keys from '@babel/runtime-corejs3/core-js-stable/object/keys';
import _Object$getOwnPropertySymbols from '@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols';
import _filterInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/filter';
import _Object$getOwnPropertyDescriptor from '@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor';
import _forEachInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/for-each';
import _Object$getOwnPropertyDescriptors from '@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors';
import _Object$defineProperties from '@babel/runtime-corejs3/core-js-stable/object/define-properties';
import _Object$defineProperty from '@babel/runtime-corejs3/core-js-stable/object/define-property';
import _defineProperty from '@babel/runtime-corejs3/helpers/defineProperty';
import _objectWithoutProperties from '@babel/runtime-corejs3/helpers/objectWithoutProperties';
import React__default from 'react';
import { c as clsx } from './clsx.m-7e9a4a81.js';

var _excluded = ["label", "size", "disabled", "className", "onChange", "clearable", "onClear", "value", "type", "plain", "textarea", "prefix", "suffix"];

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); if (enumerableOnly) { symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { var _context; _forEachInstanceProperty(_context = ownKeys(Object(source), true)).call(_context, function (key) { _defineProperty(target, key, source[key]); }); } else if (_Object$getOwnPropertyDescriptors) { _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)); } else { var _context2; _forEachInstanceProperty(_context2 = ownKeys(Object(source))).call(_context2, function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } } return target; }
var emoji = /[^\u0020-\u007E\u00A0-\u00BE\u2E80-\uA4CF\uF900-\uFAFF\uFE30-\uFE4F\uFF00-\uFFEF\u0080-\u009F\u2000-\u201f\u2026\u2022\u20ac\r\n]/g;

var Input = function Input(props, ref) {
  var label = props.label,
      size = props.size,
      disabled = props.disabled,
      className = props.className,
      _onChange = props.onChange,
      clearable = props.clearable,
      onClear = props.onClear,
      value = props.value,
      type = props.type,
      plain = props.plain,
      textarea = props.textarea,
      prefix = props.prefix,
      suffix = props.suffix,
      rest = _objectWithoutProperties(props, _excluded);

  return /*#__PURE__*/React__default.createElement("label", {
    className: clsx('smb-input', size === 'large' && 'smb-input--large', plain && 'smb-input--plain', disabled && 'smb-input--disabled')
  }, /*#__PURE__*/React__default.createElement(textarea ? 'textarea' : 'input', _objectSpread(_objectSpread({}, rest), {}, {
    type: type,
    ref: ref,
    value: value,
    className: clsx('smb-input__inner', prefix && 'smb-input__inner--has-prefix', (suffix || clearable) && 'smb-input__inner--has-suffix', className),
    disabled: disabled,
    onChange: function onChange(e) {
      return _onChange === null || _onChange === void 0 ? void 0 : _onChange(e.target.value.replace(emoji, ''));
    }
  })), label ? /*#__PURE__*/React__default.createElement("div", {
    className: "smb-input__label",
    "data-content": label + '**'
  }, label) : null, prefix ? /*#__PURE__*/React__default.createElement("div", {
    className: "smb-input__prefix"
  }, prefix) : null, suffix ? /*#__PURE__*/React__default.createElement("div", {
    className: "smb-input__suffix"
  }, suffix) : clearable && !disabled && value ? /*#__PURE__*/React__default.createElement("div", {
    className: "smb-input__suffix"
  }, /*#__PURE__*/React__default.createElement("button", {
    className: "smb-input__clear",
    type: "button",
    onClick: function onClick() {
      onClear === null || onClear === void 0 ? void 0 : onClear();
      _onChange === null || _onChange === void 0 ? void 0 : _onChange('');
    }
  }, /*#__PURE__*/React__default.createElement("svg", {
    width: "16",
    height: "17",
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M15.5 8.46289C15.5 12.605 12.1421 15.9629 8 15.9629C3.85786 15.9629 0.5 12.605 0.5 8.46289C0.5 4.32076 3.85786 0.962891 8 0.962891C12.1421 0.962891 15.5 4.32076 15.5 8.46289Z",
    fill: "white",
    stroke: "currentColor"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M6.04757 5.76833L10.6984 10.4192C10.8845 10.6052 10.9057 10.9595 10.6985 11.1631C10.493 11.3686 10.1405 11.3491 9.95452 11.1631L5.30364 6.51225C5.09821 6.30682 5.09821 5.97376 5.30364 5.76833C5.50907 5.5629 5.84214 5.5629 6.04757 5.76833Z",
    fill: "currentColor"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M9.94451 5.76866L5.29673 10.42C5.11072 10.6059 5.08952 10.9567 5.29496 11.1621C5.50039 11.3676 5.85287 11.3481 6.03888 11.1622L10.6884 6.51259C10.8939 6.30716 10.8939 5.97409 10.6884 5.76866C10.483 5.56323 10.1499 5.56323 9.94451 5.76866Z",
    fill: "currentColor"
  })))) : null);
};

var Input$1 = /*#__PURE__*/React__default.forwardRef(Input);

export { Input$1 as I };
